import { ISolutionFeatureMapping, featureMappingFallback, addCrmAndMoreEssentialsPrev } from "../components/solution-featurecode-mapping";
import { autoinject } from 'aurelia-dependency-injection';
import { HttpClient } from 'aurelia-fetch-client';


@autoinject
export class FeatureInfoStore {

    private mappingCache: ISolutionFeatureMapping = null;

    /**
     *
     */
    constructor(private http: HttpClient,) {

        http.configure(config => {
            config
                .useStandardConfiguration();
        });

    }

    async getFeatureSolutionMapping(): Promise<ISolutionFeatureMapping> {
        if (this.mappingCache) {
            return this.mappingCache;
        }

        try {
            console.log('Trying to get feature solution mapping');

            const response = await this.http.fetch('/api/featurecode/mapping');

            const mapping: ISolutionFeatureMapping = await response.json();

            // Add CRMandMore_CRMEssentials_Prev manually as it does not exist in CRM@Home
            addCrmAndMoreEssentialsPrev(mapping);

            this.mappingCache = mapping;

        } catch (error) {
            console.log('An error occurred trying to fetch feature solution mapping', error);

            this.mappingCache = featureMappingFallback; // fallback exists because solution is not up-to-date

            console.log('Set solution feature mapping fallback');
        }

        return this.mappingCache;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/services/feature-info-store.ts